module.exports = __webpack_public_path__ + "img/pop_up_2026_02_1.e7a5cd49.png";